import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { env } from '../../common/lib/env';

import { Spinner } from './Common/Spinner';

/**
 * Client-side login entry point. Marketing links point here (app.paidnice.com/login?connection=Xero&source=website)
 * instead of the API so analytics/attribution cookies are set on the app domain before the Auth0 redirect.
 * All query params are forwarded to the API's /login route untouched.
 */
export function Login() {
  const { search } = useLocation();

  useEffect(() => {
    window.location.replace(`${env.apiUrl}/login${search}`);
  }, [search]);

  return <Spinner center />;
}
